import React from "react";
import styles from "./MiniGameCard.module.scss";
import PricingFunctions from "common/PricingFunctions";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "actions/cart";
import { useSearchParams } from "react-router-dom";

const MiniGameCard = ({ game, onAddToCartOverride, discountCode, discountPercentage }) => {
    const dispatch = useDispatch();
    const pricing = useSelector((state) => state.pricing);
    const [searchParams, setSearchParams] = useSearchParams();

    const backgroundImage = game.meta?.cardBackground;
    const cardLogo = game.meta?.cardLogo;
    const accentImage = game.meta?.animatedAccent;

    const countryCode = pricing.countryCode;
    const basePrice = PricingFunctions.getGamePricing(countryCode, game).raw;
    const currency = PricingFunctions.getCurrencySymbol(countryCode);

    const hasDiscount = !!discountPercentage && discountPercentage > 0;
    const discountedPrice = hasDiscount
        ? (basePrice * (1 - discountPercentage / 100)).toFixed(2)
        : basePrice.toFixed(2);

    const handleAddToCart = () => {
        if (discountCode) {
            const updatedParams = new URLSearchParams(searchParams);
            updatedParams.set("discountCode", discountCode);
            setSearchParams(updatedParams);
        }

        if (onAddToCartOverride) {
            onAddToCartOverride(game);
        } else {
            dispatch(addToCart(game));
        }
    };

    return (
        <div className={styles.gameCardWrapper}>
            <div className={styles.gameCard} onClick={handleAddToCart}>
                <div
                    className={styles.gameCardBackground}
                    style={{ backgroundImage: `url(${backgroundImage})` }}
                >
                    <img className={styles.cardLogo} src={cardLogo} alt={`${game.name} Logo`} />
                    {accentImage && (
                        <img className={styles.cardCharacter} src={accentImage} alt="Accent" />
                    )}
                </div>
                <div className={styles.buttons}>
                    <div className={styles.addToCart}>
                        Add To Cart
                        <span className={styles.discountPrice}>
                            {hasDiscount && (
                                <span className={styles.originalPrice}>
                                    {currency}{basePrice.toFixed(2)}
                                </span>
                            )}
                            {currency}{discountedPrice}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MiniGameCard;
